import { InputNumber, Select, Checkbox, AutoComplete } from 'antd'
import { measurementUnits, volumeUnits, weightUnits } from '../../pages/add-product'
import styles from './SpecificationInput.module.css'
require('./SpecificationInput.less')

const SpecificationInput = ({
	specification,
	onChange = () => {},
	onUnitChange = () => {},
	disabled = false,
	disableUnit = false,
	placeholder,
	placeholderUnit,
	options = [],
	min = 0
}) => {

	return (
		<div className={styles.inputContainer}>
			{
				specification.type !== 'BOOLEAN' &&
				<div className={styles.title}>
					{specification.label}
				</div>
			}
			{
				specification.type === 'STRING' &&
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<AutoComplete
							className='specification-input'
							value={specification.value}
							onChange={onChange}
							placeholder='Text'
							disabled={disabled}
							options={specification.productSpecifications}
							filterOption={(inputValue, option) =>
								option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
						/>
					</div>
			}
			{
				specification.type === 'LENGTH' &&
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<InputNumber
							className='specification-number-input'
							value={specification.value}
							onChange={onChange}
							placeholder='Measurement'
							min={0}
							onFocus={e => e.target.select()}
							disabled={disabled}
						/>
						<Select
							className='specification-select'
							placeholder='Unit'
							value={specification.unit}
							onChange={onUnitChange}
							options={measurementUnits}
							disabled={disabled || disableUnit}
						/>
					</div>
			}
			{
				specification.type === 'WEIGHT' &&
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<InputNumber
							className='specification-number-input'
							value={specification.value}
							onChange={onChange}
							placeholder='Weight'
							min={0}
							onFocus={e => e.target.select()}
							disabled={disabled}
						/>
						<Select
							className='specification-select'
							placeholder='Unit'
							value={specification.unit}
							onChange={onUnitChange}
							options={weightUnits}
							disabled={disabled || disableUnit}
						/>
					</div>
			}
			{
				specification.type === 'BOOLEAN' &&
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<Checkbox
							checked={specification.value === 'true'}
							onChange={e => onChange(`${e.target.checked}`)}
							disabled={disabled}
						/>
						<div className={styles.title} style={{ marginLeft: 12 }}>
							{specification.label}
						</div>
					</div>
			}
			{
				specification.type === 'VOLUME' &&
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<InputNumber
							className='specification-number-input'
							value={specification.value}
							onChange={onChange}
							placeholder='Volume'
							min={0}
							onFocus={e => e.target.select()}
							disabled={disabled}
						/>
						<Select
							className='specification-select'
							placeholder='Unit'
							value={specification.unit}
							onChange={onUnitChange}
							options={volumeUnits}
							disabled={disabled || disableUnit}
						/>
					</div>
			}
			{
				specification.type === 'NUMBER' &&
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<InputNumber
							className='specification-number-input'
							value={specification.value}
							onChange={onChange}
							placeholder='Number'
							onFocus={e => e.target.select()}
							disabled={disabled}
						/>
					</div>
			}
			{
				specification.type === 'CUSTOM_NUMBER' &&
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<InputNumber
							className='specification-number-input'
							value={specification.value}
							onChange={onChange}
							placeholder={placeholder}
							min={min || 0}
							onFocus={e => e.target.select()}
							disabled={disabled}
						/>
						<Select
							className='specification-select'
							placeholder={placeholderUnit}
							value={specification.unit}
							onChange={onUnitChange}
							options={options}
							disabled={disabled || disableUnit}
						/>
					</div>
			}
		</div>
	)
}

export default SpecificationInput
